import {GeomRelation} from "./geom-relation";

class VectorByTwoPoints extends GeomRelation {
    constructor (pointA, pointB, vector) {
        super();
        if (arguments.length === 3) {
            this.pointA = pointA;
            this.pointB = pointB;
            this.vector = vector;
            this.objectId =
                window.cabri.emsc.createVectorByTwoPoints(pointA.objectId,
                    pointB.objectId, vector.objectId);
        }
        else {
            this.objectId = pointA;
        }
    }

    dispose () {
        // TODO
        // window.cabri.emsc.deleteVectorByTwoPoints(idVector);
        super.dispose();
    }
}

export {VectorByTwoPoints}